/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Button from "@mui/material/Button";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

const GUISwitch = styled(Switch)(({ theme, lang }) => ({
  padding: 0,
  width: 60,
  height: 28,
  borderRadius: 14,
  background: 'linear-gradient(#1c1c1d,#17191a)',
  // background: 'red',
  borderBottom: '1px outset hsla(0,0%,100%,.15)',
  borderTop: '1px outset transparent',
  boxShadow: 'inset 0 4px 4px #000',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 22,
      height: 22,
      lineHeight: '22px',
      textAlign: 'center',
      fontSize: 14,
      color: '#ffffff',
    },
    '&::before': {
      content: '"EN"',
      left: -24,
    },
    '&::after': {
      content: `'${lang}'`,
      right: -24,
    },
    '&.Mui-checked': {
      transform: 'translateX(34px)',
    },
    '&.Mui-checked + .MuiSwitch-track': {
      background: 'transparent',
    },
  },
  '& .MuiSwitch-thumb': {
    background: 'linear-gradient(180deg,#0156c9,#01449d)',
    boxShadow: '2px 0 2px rgba(0,0,0,.25)',
    width: 22,
    height: 22,
    margin: 2,
  },
  '& .MuiSwitch-track': {
    background: 'transparent',
    opacity: 1,
  },
}));

function GUIHeader(props) {
  const { lesson, lang, languageToggle, handleLanguageToggle } = props;
  // popover
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div 
      className="flex px-16 py-8 w-full items-center shadow-md mt-16 mb-0"
      style={{
        background: 'linear-gradient(180deg,#282828,#181818)',
        color: 'common.white',
        borderBottom: 'solid 1px #000',
        borderTop: '1px solid rgba(255,255,255,.15)'
      }}  
    >
      <div className="flex grow">
        <div
          style={{
            color: '#ffffff',
          }}
          className="text-base font-bold mr-16"
        >
          {lesson}
        </div>
        <div 
          style={{
            color: '#b6b6b7',
            letterSpacing: '4px'
          }}
          className="text-base font-normal"
        >
          | UNCLASSIFIED
        </div>
      </div>
      <div className="flex">
        <FormControlLabel
          control={
            <GUISwitch 
              lang={lang.toUpperCase()} 
              checked={languageToggle}
              onChange={handleLanguageToggle}
            />
          }
        />
        <Button 
          aria-describedby={id}
          variant="contained"
          color="error"
          className="font-semibold py-0 px-8 rounded leading-4 h-32 min-h-32"
          endIcon={<ExitToAppIcon />}
          onClick={handleClick}
          style={{
            background: 'linear-gradient(#d6484b,#c14245)',
            outline: 'solid 3px #000',
          }}
        >
          EXIT
        </Button>
        <Popover 
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Typography sx={{ p: 2 }}>Exit Disabled</Typography>
        </Popover>
      </div>
    </div>
  );
}

export default GUIHeader;